export default {
  dataEntryModeStyle(dataEntryMode) {
    switch (dataEntryMode) {
      case 'CIE':
      case 'CNS':
      case 'MANUAL':
        return (['badge', 'badge-pill', 'badge-success']);
      case 'DIGITALIZED_MANUAL':
      case 'DIGITALIZED_MORE':
      case 'DIGITALIZED_MORE_MODIFIED':
        return (['badge', 'badge-pill', 'badge-secondary']);
      case 'WEB_CONAD':
        return (['badge', 'badge-pill', 'badge-warning']);
    }
  },
  showDataEntryModePill(dataEntryMode) {
    switch (dataEntryMode) {
      case 'CIE':
      case 'CNS':
      case 'MANUAL':
      case 'DIGITALIZED_MANUAL':
      case 'DIGITALIZED_MORE':
      case 'DIGITALIZED_MORE_MODIFIED':
      case 'WEB_CONAD':
        return true;
      default:
        return false;
    }
  },
  procedureStyle(procedureChoice) {
    switch (procedureChoice) {
      case 'NEW':
        return (['badge', 'badge-pill', 'badge-primary']);
      case 'REISSUE':
        return (['badge', 'badge-pill', 'badge-success']);
      case 'UPDATE':
        return (['badge', 'badge-pill', 'badge-info']);
      case 'ADMIN_UPDATE':
        return (['badge', 'badge-pill', 'badge-info']);
      case 'HIDE':
        return (['badge', 'badge-pill', 'badge-warning']);
    }
  }
}
